import { ajaxPostJson,setParams } from './ajax';
/* 平台管理员统计接口*/
//获取统计数量
export const getStatisticsQuantity  = (params) => {
  return ajaxPostJson(`/user/getAdminStatistical`, params,'BaseApi');
}; 

//统计排行
export const getStatisticsRankings  = (params) => {
  return ajaxPostJson(`/user/getAdminRankList`, params,'BaseApi');
};
// 语言对下拉框数据查询
// export const queryLanguage= (params) => {
//   return ajaxPostJson(`/project/queryLangDescAndCodeList`, params);
// };

// 源语言与目标语言
export const queryLangList = (params) => {
  return ajaxPostJson(`/common/queryLangList`, params);
};

/* 用户统计接口 */

export const getUserStatisticsList = (params) => {
  return ajaxPostJson(`/user/getUserStatistical`, params,'BaseApi');
}; 

//用户统计表格
export const userStatisticsForm = (params) => {
  params.filter=setParams(params.filter)
  return ajaxPostJson(`/user/queryUserStatisticalPage`, params,'BaseApi');
}; 
// 查询所有领域
export const queryDomainList = (params) => {
  return ajaxPostJson(`/project/queryDomainList`, params);
};
//导出
export const exportList = (params) => {
  params.filter=setParams(params.filter)
  return ajaxPostJson(`/user/queryUserStatisticalToExcel`, params);
};



//统计新接口

//获取头部数据
export const headerData = (params) => {
  return ajaxPostJson(`/project/countStatisticalNum`, params);
};
//获取项目分页
export const projectQueryPage = (params) => {
  return ajaxPostJson(`/project/countClassifyProjectNum`, params);
};
//获取任务分页
export const taskQueryPage = (params) => {
  return ajaxPostJson(`/fileTask/countTaskClassifyNum`, params);
};
//获取翻译文件
export const fileQueryPage = (params) => {
  return ajaxPostJson(`/file/getCountTransCompleteFileNum`, params);
};
//记忆库
export const memoryQueryPage = (params) => {
  return ajaxPostJson(`/memory/getMemoryLangDescClassifyNum`, params);
};
//术语库
export const termQueryPage = (params) => {
  return ajaxPostJson(`/term/getTermLangDescClassifyNum`, params);
};
//下载
export const downLoadFile = (params) => {
  return ajaxPostJson(`/fileTask/downloadStatisticalReport`, params);
};
//轮询下载
export const getDownloadAsyncResult = (params) => {
  return ajaxPostJson(`/fileTask/getDownloadStatisticalAsyncResult`, params);
};